import * as yup from "yup";
import type { Asserts } from "yup";

// Response from here autosuggest endpoint validation

const itemSchema = yup.object({
  id: yup.string().required(),
  title: yup.string().required(),
});

const addressesSchema = yup.object({ items: yup.array().of(itemSchema) });

export type TAddressResponseItem = Asserts<typeof itemSchema>;

export type TAddressesResponse = Asserts<typeof addressesSchema>;

const validateAddressesResponse = (response: any): TAddressesResponse => addressesSchema.validateSync(response);

export default validateAddressesResponse;
